<template>
  <v-footer
    app
    padless
  >
    <v-card
      class="text-center w-full left-menu-opacity"
      :color="backgroundColor"
      tile
    >
      <v-card-text
        class="pt-2 pb-2 text-copyright"
      >
        &copy;<strong>Cyberlogitec</strong> {{ new Date().getFullYear() }}
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  computed: {
    backgroundColor() {
      return this.$vuetify.theme.dark ? '#2C2C2C' : '#242A33';
    },
  },
}
</script>
<style>
.text-copyright{
  color: rgba(255, 255, 255, 0.7) !important;
}
</style>